import { tempMeeApi } from '~/services/api';
import type {
  IRefreshSessionApiEnvelope,
  IRefreshSessionApiPayload,
  TRefreshSessionApiResponse,
} from '../types/SignUp.api';

export const refreshSession = async (
  payload: IRefreshSessionApiPayload,
): Promise<TRefreshSessionApiResponse> => {
  const { data: envelope } = await tempMeeApi.post<IRefreshSessionApiEnvelope>(
    '/auth-service/sessions/refresh',
    payload,
  );
  return envelope.data;
};
